<template>
    <svg style="width: 24px; height: 16px; vertical-align: middle; border:1px solid #cccccc" v-bind="$props" v-html="icon"></svg>
</template>

<script>
import PropsMixin from "@/components/General/Icon/Mixin/PropsMixin";
import { countries } from 'country-flag-icons'
import * as countryFlags from 'country-flag-icons/string/3x2'

export default {
    mixins: [PropsMixin],
    props: {
        code: {
            required: false,
            type: String,
            default: null,
        },
    },
    computed: {
        icon() {
            if (countries.includes(this.code)) {
                return countryFlags[this.code];
            }

            return '<svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-xx" viewBox="0 0 640 480">\n' +
                '  <path id="rect27" d="M.5.5h638.9v478.9H.5z" style="fill:#fff;fill-opacity:1;fill-rule:evenodd;stroke:#adb5bd;stroke-width:1.0804;stroke-opacity:1"/>\n' +
                '  <path id="path2797" d="m.5.5 639 479" style="fill:none;stroke:#adb5bd;stroke-width:16.0804px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"/>\n' +
                '  <path id="path2799" d="m639.5.5-639 479" style="fill:none;stroke:#adb5bd;stroke-width:16.0804px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"/>\n' +
                '</svg>\n';
        }
    }
}
</script>
